// import React from 'react';
// import './blog_hero.css';
// import vynlogo from '../../img/des_sec/vyn_content.svg'; // Adjust the path as necessary

// const BlogHero = () => {
//   return (
//     <section className="hero-container-bh">
//       <div className="hero-content-bh">
       
        
//         <h1 className="hero-title-bh">
//           <span className='hero-title-bh2'></span> <span className="highlight-text-bh">Blogs</span>
//         </h1>
        
//         <p className="hero-description-bh">
//         The Why Behind WikiWorks
//         </p>
//       </div>
      
//       {/* <div className="wave-bottom-bh"></div> */}
//     </section>
//   );
// };

// export default BlogHero;
import React from 'react';
import './blog_hero.css';
import vynlogo from '../../img/des_sec/vyn_content.svg';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';

const BlogHero = () => {
  const [refTitle, inViewTitle] = useInView({ triggerOnce: false, threshold: 0.1 });
  const [refDesc, inViewDesc] = useInView({ triggerOnce: false, threshold: 0.1 });

  const titleAnimation = useSpring({
    opacity: inViewTitle ? 1 : 0,
    transform: inViewTitle ? 'translateY(0)' : 'translateY(40px)',
    config: { duration: 700 },
  });

  const descriptionAnimation = useSpring({
    opacity: inViewDesc ? 1 : 0,
    transform: inViewDesc ? 'translateY(0)' : 'translateY(40px)',
    config: { duration: 700, delay: 300 },
  });

  return (
    <section className="hero-container-bh">
      <div className="hero-content-bh">
        <animated.h1 className="hero-title-bh" ref={refTitle} style={titleAnimation}>
          <span className='hero-title-bh2'></span> <span className="highlight-text-bh">Blogs</span>
        </animated.h1>

        <animated.p className="hero-description-bh" ref={refDesc} style={descriptionAnimation}>
          Explore insights, stories, and ideas from the people behind <br /> WikiWorks—where innovation meets community.
        </animated.p>
      </div>
    </section>
  );
};

export default BlogHero;